import React, { useState } from 'react';

interface Tab {
  id: string;
  label: string;
  href: string;
  target: string;
}

interface TabbedNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabClick: (tabId: string) => void;
}

const TabbedNavigation: React.FC<TabbedNavigationProps> = ({ tabs, activeTab, onTabClick }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleHomeClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const handleTabClick = (tabId: string) => {
    onTabClick(tabId);
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="tabbed-navigation">
      <div className="nav-container">
        {/* Home Icon Button */}
        <button
          className="nav-tab nav-tab-home"
          onClick={handleHomeClick}
          title="Back to top"
        >
          <img 
            src="/images/icon.png" 
            alt="Home" 
            className="nav-icon"
          />
        </button>
        
        {/* Desktop Navigation Tabs */}
        <div className="nav-tabs-desktop">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => handleTabClick(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Mobile Hamburger Menu */}
        <div className="nav-mobile">
          <button
            className="hamburger-menu"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`mobile-menu-item ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default TabbedNavigation;
